<template>
    <div class="max-w-[350px] relative">
        <p class="font-bold" :class="enable ? 'text-black' : 'text-gray-400'">
            {{ title }}
        </p>
        <div class="relative">
            <button
                :disabled="!enable"
                @click.prevent="
                    showSelectParticipants = !showSelectParticipants
                "
                :class="
                    enable
                        ? 'text-black border-gray-500 focus:border-gray-300'
                        : 'text-gray-400 bg-[#CDCDCD]'
                "
                class="transition-all form-select border rounded-2xl w-full text-left max-h-[42px] mt-1 hover:bg-gray-300 hover:border-gray-300 whitespace-nowrap overflow-x-hidden overflow-ellipsis"
            >
                <input
                    v-if="checkedValues.length"
                    type="radio"
                    id="two"
                    value="Dois"
                    checked
                />
                {{ checkedValues.length ? `Selecionados: ${checkedValues.length}` : placeholder }}
            </button>
        </div>
        <div v-show="showSelectParticipants">
            <div class="relative">
                <input
                    v-model="searchName"
                    placeholder="Faça sua pesquisa aqui"
                    class="text-black border-gray-500 focus:border-gray-500 transition-all form-select border rounded-2xl w-full text-left max-h-[42px] mt-1"
                />
                <div
                    v-if="enable"
                    class="flex justify-center items-center absolute top-[5px] right-[1px] h-[40px] w-[40px] rounded-2xl bg-gray-200"
                    @click.prevent="
                        showSelectParticipants = !showSelectParticipants
                    "
                >
                    <Icon name="Pesquisar" class="w-[16px]" />
                </div>
            </div>
            <div
                v-if="filteredOptions?.length"
                class="flex flex-col overflow-hidden w-full border border-gray-500 bg-white rounded-2xl mt-2 overflow-y-scroll max-h-[40vh]"
            >
                <label
                    class="flex items-center gap-x-2 p-2 border-t-2 first:border-t-0"
                    v-for="option in filteredOptions"
                    :key="option.id"
                >
                    <input
                    :key="option.id"
                    type="checkbox"
                    :checked="isChecked(option)"
                    @change="toggleSelection(option, $event)"
                    />
                        <p>{{ option.name }}</p>
                </label>
            </div>
            <div v-else class="grid my-2">
                <label class="text-center text-lg text-[#808080]">
                    Não encontramos nenhum resultado para o termo digitado
                </label>
            </div>
        </div>
    </div>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";

export default {
    components: {
        Icon,
    },
    props: {
        title: String,
        options: Object,
        enable: {
            type: Boolean,
            default: true,
        },
        order: {
            type: Boolean,
            default: true,
        },
        placeholder: String,
        onChange: Object,
        clear: false,
        initialValue: Object,
        modelValue: Object,
    },
    data() {
        return {
            searchName: "",
            checkedValues: this.initialValue,
            showSelectParticipants: false,
            isSyncingFromChild: false,
        };
    },
    computed: {
        filteredOptions() {
            return this.orderedOptions.filter(
                (user) =>
                    user?.name
                        .toLowerCase()
                        .indexOf(this.searchName.toLowerCase()) > -1
            );
        },
        orderedOptions() {
            return this.order? this.options.sort((a, b) => (a.name > b.name ? 1 : -1)): this.options;
        },
    },
    watch: {
    clear() {
        if (this.clear) {
        this.checkedValues = [];
        }
    },

    initialValue: {
        handler(newValue) {
        if (this.isSyncingFromChild) return;

        if (newValue === true) {
            this.checkedValues = Array.isArray(this.options) ? [...this.options] : [];
        } else if (Array.isArray(newValue)) {
            this.checkedValues = [...newValue];
        } else {
            this.checkedValues = [];
        }
        },
        immediate: true,
    },

    checkedValues: {
        handler(newValue) {
        this.isSyncingFromChild = true;
        this.$emit("updateValue", newValue);
        this.$nextTick(() => {
            this.isSyncingFromChild = false;
        });
        },
        deep: true,
    },
    },
    methods: {
    /**
     * Verifica se o item deve aparecer marcado.
     * Usa comparação por id para evitar falha de referência.
     */
    isChecked(option) {
      if (Array.isArray(this.checkedValues)) {
        return this.checkedValues.some((v) => v.id === option.id);
      }
      return false;
    },

    /**
     * Marca/desmarca o item e sincroniza com checkedValues.
     */
    toggleSelection(option, event) {
      let newValues = Array.isArray(this.checkedValues)
        ? [...this.checkedValues]
        : [];

      if (event.target.checked) {
        if (!newValues.some((v) => v.id === option.id)) {
          newValues.push(option);
        }
      } else {
        newValues = newValues.filter((v) => v.id !== option.id);
      }

      this.checkedValues = newValues;
    },
  },
};
</script>
